var crypto = require('crypto')
var assert = require('nanoassert')

var KEYLEN = 32
var NONCELEN = 8
var MACLEN = 16

function encrypt(k, n, ad, plaintext) {
  assert(k.length === KEYLEN)
  assert(n.length === NONCELEN)
  assert(Buffer.isBuffer(plaintext), 'plaintext must be a Buffer')

  var iv = Buffer.concat([Buffer.alloc(4), n])

  var cipher = crypto.createCipheriv("aes-256-gcm", k, iv)
  if (ad) {
    cipher.setAAD(ad)
  }

  var buffer = cipher.update(plaintext)
  return Buffer.concat([buffer, cipher.final(), cipher.getAuthTag()])
}

function decrypt(k, n, ad, ciphertext) {
  assert(k.length === KEYLEN)
  assert(n.length === NONCELEN)
  assert(Buffer.isBuffer(ciphertext), 'ciphertext must be a Buffer')

  var iv = Buffer.concat([Buffer.alloc(4), n])

  var decipher = crypto.createDecipheriv("aes-256-gcm", k, iv)
  if (ad) {
    decipher.setAAD(ad)
  }
  decipher.setAuthTag(Buffer.from(ciphertext.subarray(ciphertext.length - MACLEN)))

  var buffer = decipher.update(Buffer.from(ciphertext.subarray(0, ciphertext.length - MACLEN)))
  return Buffer.concat([buffer, decipher.final()])
}

var maxnonce = Buffer.alloc(8, 0xff)
var zerolen = Buffer.alloc(0)
var zeros = Buffer.alloc(32, 0)

function rekey(k) {
  return encrypt(k, maxnonce, zerolen, zeros).slice(0, 32)
}

module.exports = {
  KEYLEN,
  NONCELEN,
  MACLEN,
  encrypt,
  decrypt,
  rekey
}